(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('UtenteSearch', UtenteSearch);

    UtenteSearch.$inject = ['$resource'];

    function UtenteSearch($resource) {
        var resourceUrl =  'api/_search/utentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
